import api from './api';
import { Asset, PaginatedResponse } from '../types';

export interface CreateAssetRequest {
  name: string;
  dataUid?: string;  // External identifier for data lookups (ticker, ID, etc.)
  type?: 'company' | 'fund' | 'property' | 'other';
  sector?: string;
  notes?: string;  // User's own notes about this coverage
  status?: 'active' | 'monitoring' | 'exited';
}

export interface UpdateAssetRequest {
  name?: string;
  dataUid?: string;  // External identifier for data lookups (ticker, ID, etc.)
  type?: 'company' | 'fund' | 'property' | 'other';
  sector?: string;
  notes?: string;  // User's own notes about this coverage
  status?: 'active' | 'monitoring' | 'exited';
}

export const assetService = {
  getAssets: async (page = 1, pageSize = 50): Promise<PaginatedResponse<Asset>> => {
    const response = await api.get<PaginatedResponse<Asset>>('/assets', {
      params: { page, pageSize },
    });
    return response.data;
  },

  getAsset: async (id: string): Promise<Asset> => {
    const response = await api.get<Asset>(`/assets/${id}`);
    return response.data;
  },

  createAsset: async (data: CreateAssetRequest): Promise<Asset> => {
    const response = await api.post<Asset>('/assets', data);
    return response.data;
  },

  updateAsset: async (id: string, data: UpdateAssetRequest): Promise<Asset> => {
    const response = await api.put<Asset>(`/assets/${id}`, data);
    return response.data;
  },

  deleteAsset: async (id: string): Promise<void> => {
    await api.delete(`/assets/${id}`);
  },
};
